'use strict';

const isRestrictedLensProduct = $('.grid-lentes-config').data('restricted-lens-product');
const isFlowStoreSubscription  = $("input[name='isFlowStoreSubscription']").data('flow-store-subscription');
const lensRestrictions = (function() {
    try {
        return $('.lens-restrictions').val() ? JSON.parse($('.lens-restrictions').val()) : null;
    } catch(e) {
        return null;
    }
})();

let applicableRestrictions = [];

const resolveRestriction = (sphValue) => {
    let restriction;

    for (let i = 0; i < applicableRestrictions.length; i++) {
        let lensRestriction = applicableRestrictions[i];
        if(sphValue <= lensRestriction.max && sphValue >= lensRestriction.min) {
            restriction = lensRestriction;
            break;
        }
    }

    return restriction;
}

const handleSphChange = (ev) => {
    const itemsColumn = $(ev.target).parents('.items-column');
    const sphValue = itemsColumn.find('.selecciona-sph').val();

    const cylSelector = itemsColumn.find('.selecciona-cyl');

    cylSelector.find('option').each((index, option) => {
        $(option).prop('disabled', true);
    });

    let restriction = resolveRestriction(sphValue);

    if (restriction) {
        cylSelector.find('option').each((index, option) => {
            if(index !== 0) {
                if(!restriction.items[option.value] || (restriction.items[option.value] && restriction.items[option.value].length > 0)) {
                    $(option).prop('disabled', false);
                }
            }
        });
    } else {
        cylSelector.find('option').each((index, option) => {
            if(index !== 0) {
                $(option).prop('disabled', false);
            }
        });
    }

    if (!isFlowStoreSubscription) {
        cylSelector.children('option:enabled').eq(0).prop('selected',true);
        cylSelector.trigger('change');
    }
};

const handleCylChange = (ev, currentRestriction) => {
    const itemsColumn = $(ev.target).parents('.items-column');
    const restriction = currentRestriction ? currentRestriction :  resolveRestriction(itemsColumn.find('.selecciona-sph').val());

    const cylValue = itemsColumn.find('.selecciona-cyl').val();
    const axisSelector = itemsColumn.find('.selecciona-axis');

    axisSelector.find('option').each((index, option) => {
        $(option).prop('disabled', true);
    });

    if(restriction) {
        axisSelector.find('option').each((index, option) => {
            if(index !== 0) {
                if(!restriction.items[cylValue] || (restriction.items[cylValue] && !restriction.items[cylValue].includes(option.value)) ) {
                    $(option).prop('disabled', false);
                }
            }
        });
    } else {
        axisSelector.find('option').each((index, option) => {
            if(index !== 0) {
                $(option).prop('disabled', false);
            }
        });
    }

    axisSelector.children('option:enabled').eq(0).prop('selected',true);
};

const initializeSelectors = (ev) => {
    if (applicableRestrictions) {
        $('.selecciona-sph').trigger('change');
    }
}

const resolveApplicableRestrictions = () => {
    const pid = $('.pdp.container.product-detail.product-wrapper').data('pid');
    Object.keys(lensRestrictions).forEach((key) => {
        const restrictionSKUs = key.split(',');
        if(restrictionSKUs.includes(pid)) {
            applicableRestrictions = lensRestrictions[key];
        }
    });

    if(!applicableRestrictions) {
        applicableRestrictions = [];
    }
}

module.exports = {
    init: function () {
        $(document).ready(function () {
            if($('.item-selector.selecciona-sph').length > 0 && isRestrictedLensProduct && lensRestrictions) {
                resolveApplicableRestrictions();
                initializeSelectors();
            }
        });

        if($('.item-selector.selecciona-sph').length > 0 && isRestrictedLensProduct && lensRestrictions) {
            $('.item-selector.selecciona-sph').on('change', handleSphChange);
            $('.item-selector.selecciona-cyl').on('change', handleCylChange);
        }
    }
};
